import { IApp } from '@/types/nuxt'
import refresh from '@/utils/refresh'

export default class GetMeUseCase implements BaseUseCase {
  constructor(protected App: IApp) {}

  async execute() {
    try {
      await refresh(this.App)
      this.App.user.current = await this.App.monitaroGateway.Auth.GetMe()
      return true
    } catch (exception: any) {
      this.App.logService.handle(exception)
    }
    return false
  }
}
